import { reactive } from "vanjs-ext";
import { router } from "..";
import { impersonate } from "../api/admin";
import {
	delFencealarmSubscription,
	getFenceAlarm,
	putFencealarmTrial,
} from "../api/fencealarms_{imei}";
import { state } from "../state";
import { centeredBox } from "../van/centered-box";
import { a, button, div, hr, input, li, nav, pre, ul } from "../van/van-tags";
import { errorToast } from "../view/components";

/**
 * @param {import("navigo").Match} ctx
 */
export async function adminFaPage(ctx) {
	if (!ctx.data?.imei) throw "missing ctx.data.imei";

	const page = reactive({
		fa: await getFenceAlarm(ctx.data.imei),
		loading: false,
		trialDays: "",
	});

	const onClickAddTrial = () => {
		page.loading = true;
		putFencealarmTrial(page.fa.Imei, +page.trialDays)
			.then((fa) => {
				page.fa = fa;
			})
			.catch(errorToast)
			.finally(() => {
				page.loading = false;
			});
	};

	const onClickCancelSubscription = () => {
		page.loading = true;
		delFencealarmSubscription(page.fa.Imei)
			.then((fa) => {
				page.fa = fa;
			})
			.catch(errorToast)
			.finally(() => {
				page.loading = false;
			});
	};

	const onClickImpersonate = () => {
		page.loading = true;
		impersonate("fencealarm", page.fa.Imei)
			.then((user) => state.startImpersonating(user))
			.then(() => router.jump("/devices"))
			.catch(errorToast)
			.finally(() => {
				page.loading = false;
			});
	};

	return centeredBox(
		{
			size: "narrow",
		},
		nav(
			{
				class: "breadcrumb",
			},
			ul(
				li(
					a(
						{
							onclick: () => router.jump("/admin"),
						},
						"Admin",
					),
				),
				li(a("FenceAlarm")),
			),
		),
		div(
			{
				class: "buttons",
			},
			button(
				{
					class: () =>
						page.loading
							? "button is-primary is-loading"
							: "button is-primary",
					disabled: () => page.loading,
					onclick: onClickImpersonate,
				},
				"Impersonate owner",
			),
			button(
				{
					class: () =>
						page.loading
							? "button is-primary is-loading"
							: "button is-primary",
					disabled: () => page.loading,
					onclick: onClickCancelSubscription,
				},
				"Cancel subscription",
			),
		),
		div(
			{
				class: "field has-addons",
			},
			div(
				{
					class: "control is-expanded",
				},
				input({
					class: "input",
					oninput: (e) => {
						page.trialDays = e.target.value.replace(/\D/g, "");
						e.target.value = page.trialDays;
					},
					placeholder: "Days",
				}),
			),
			div(
				{
					class: "control",
				},
				button(
					{
						class: () =>
							page.loading
								? "button is-primary is-loading"
								: "button is-primary",
						disabled: () => page.fa === null || page.loading,
						onclick: onClickAddTrial,
					},
					"Add trial",
				),
			),
		),
		hr(),
		pre({ class: "is-tiny-mobile" }, () =>
			JSON.stringify(page.fa, null, 2),
		),
	);
}
